import { Model } from "@interfaces/model.interface";

export interface ProtectedGrid extends Model {
	grid: string;
	groups: string;
}

export class ProtectedGrid implements ProtectedGrid {	
	constructor(data?: Partial<ProtectedGrid>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}